module.exports = __webpack_public_path__ + "6a0212390ef38b81c19a1be315ec3d31.svg";